import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {CostHistory} from '../../../shared/models/cost-history.model';

@Component({
  selector: 'app-cost-history',
  templateUrl: './cost-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostHistoryComponent implements OnInit {
  @Input() costHistory: CostHistory[];

  constructor() { }

  ngOnInit() {
  }

}
